import React from "react";
import CourseCategoryManager from "./CourseCategoryManager";

function AddCategory() {
  return <CourseCategoryManager />;
}

export default AddCategory;
